import axiosInstance from '../../api/axios';

export type RecommendControlsRiskInput = {
  risk_name?: string;
  risk_description: string;
  risk_category?: string;
  risk_level?: string;
};

export type RecommendControlsProcessInput = {
  name: string;
  description?: string;
};

export type RecommendedControlSuggestion = {
  title: string;
  control_wording_text: string;
};

export async function recommendControlsForRisk(
  risk: RecommendControlsRiskInput,
  process: RecommendControlsProcessInput
): Promise<RecommendedControlSuggestion[]> {
  const response = await axiosInstance.post('/api/controls/recommend-for-risk', {
    risk,
    process,
  });
  if (response?.data?.error) {
    throw new Error(String(response.data.error));
  }
  const controls = Array.isArray(response?.data?.controls) ? response.data.controls : [];
  return controls
    .map((item) => ({
      title: String(item?.title ?? '').trim(),
      control_wording_text: String(
        item?.control_wording_text ?? item?.controlWordingText ?? ''
      ).trim(),
    }))
    .filter((item) => item.title && item.control_wording_text)
    .slice(0, 3);
}

export type CreateAiAssistedControlResult = {
  id: string;
  control_id: string;
  client_control_id: string;
};

/** Create a control from an AI recommendation (source=ai_assisted). */
export async function createAiAssistedControl(input: {
  title: string;
  controlWordingText: string;
}): Promise<CreateAiAssistedControlResult> {
  const tempClientId = `AI-${Date.now()}`;
  const response = await axiosInstance.post('/api/sox-controls', {
    title: input.title,
    control_wording_text: input.controlWordingText,
    client_control_id: tempClientId,
    source: 'ai_assisted',
    status: 'draft',
  });
  const data = response?.data ?? {};
  const id = String(data.id ?? '').trim();
  const controlId = String(data.control_id ?? data.controlId ?? '').trim();
  const clientControlId = String(data.client_control_id ?? data.clientControlId ?? '').trim();
  if (!id) {
    throw new Error(data.error || 'Failed to create control');
  }
  return {
    id,
    control_id: controlId,
    client_control_id: clientControlId || controlId || tempClientId,
  };
}
